/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: prop-types library.
import _ from 'underscore' // Npm: underscore library.
import { useQuery } from '@apollo/client' // Npm: Apollo client.


/*
 * PACKAGES
 */
import { MemoizedSelect } from 'components/MemoizedInput'


/*
 * GRAPHS
 */
import CustomerAccountReadQuery from './__query__/index.customerAccount.read.query'


/*
 * OBJECTS
 */
const Index = ({ onChange, customerType, accountId, onLoad, ...props }) => {
  // Const assignment.
  const _skipDifference = 10000

  // Hook assignment.
  const _QueryCustomerAccountRead = useQuery(CustomerAccountReadQuery, { 'variables': { accountId, customerType, 'take': _skipDifference, 'skip': 0 }, 'fetchPolicy': Object.React.App.fetchPolicy, 'pollInterval': Object.React.App.pollInterval })

  // IDs pass.
  React.useEffect(() => {
    // If CustomerAccountRead is present then
    // return those customer account ids.
    if (_QueryCustomerAccountRead?.data?.CustomerAccountRead && onLoad) {
      // Return the customer account ids.
      onLoad(_.compact(_QueryCustomerAccountRead.data.CustomerAccountRead.map(item => item.id)))
    }
  }, [_QueryCustomerAccountRead?.data?.CustomerAccountRead, onLoad])

  // Return component.
  return (
    <MemoizedSelect
      onChange={onChange}
      value={props.value ?? props.data}
      placeholder='Select customer account'
      options={_.compact(_QueryCustomerAccountRead?.data?.CustomerAccountRead?.map(({ id, displayName, Customer }) => {
        // If customerType is present then
        // filter out those customer accounts.
        if (customerType && Customer?.type !== customerType) return void 0

        // Return the customer account.
        return displayName && id ? `${displayName} (${id})` : void 0
      }))
        .sort((a, b) => {
          const labelA = a.split(' (')[0].toLowerCase()
          const labelB = b.split(' (')[0].toLowerCase()
          return labelA.localeCompare(labelB)
        })
      }
      {...props}
    />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'onChange': PropTypes.func.isRequired,
  'customerType': PropTypes.string,
  'accountId': PropTypes.string,
  'onLoad': PropTypes.func,
  'value': PropTypes.string,
  'data': PropTypes.string
}


/*
 * EXPORT
 */
export default Index
